"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var big_decimal_1 = require("@logio/big-decimal");

var PriceFormulas_1 = require("../../core/model/math/PriceFormulas");

var RealImpactValue_1 = require("./RealImpactValue");
/**
 * <p>
 * Mutable representation of the real impact. The builders have the ability to combine themselves
 * to aggregate impacts of smaller units providing impact of the bigger unit, see add method.
 * </p>
 *
 * <p>
 * Examples of combinations: impact of a product for different days to produce impact of the
 * whole week, impact of a products in category to produce impact of the whole category, etc.
 * </p>
 *
 * TODO Verify with the client, whether sales volume impact (and maybe other KPIs) should be calculated even for obsolete forecast, based on
 * TODO another sum of amount which would contain real sales only till forecast is valid.
 */


var RealImpactBuilder =
/*#__PURE__*/
function () {
  /**
   * @param marginForAmount Expected margin for units sold, in CZK – combines as sum (sum is weighted by real transaction amount,
   *        not forecast amount). Whether the old or new margin should be used as a base determines whether the item has been exported
   *        or not. If it was, margin new should be used, if not, margin old should be used instead.
   * @param profitForAmount Expected profit for units sold, in CZK – combines as sum (sum is weighted by real transaction amount,
   *        not forecast amount). Whether the old or new profit should be used as a base determines whether the item has been exported
   *        or not. If it was, profit new should be used, if not, profit old should be used instead.
   * @param forecast Expected sales volume for X day (X depends on how many days you process at once), as per release – combines as sum.
   *        Whether the forecast for old or new price should be used as a base determines whether the item has been exported or not. If it
   *        was, forecast for new price should be used, if not, forecast for old price should be used instead. for some types of releases,
   *        currently only the regular type, the sum of forecasts includes only the period for which the forecast is valid. Sales volume
   *        impact computed as real amount subtract expected forecast should be calculated only if forecast is not obsolete for period.
   * @param forecastObsolete If true, forecast combined as sum does not cover the entire period due to its expiration. Combines as logical
   *        OR operation.
   * @param revenueForAmount Expected revenue for units sold, in CZK (forecast times expected unit price) – combines as sum.
   *        TODO verify whether final price should not be used instead of ARP.
   * @param revenueWithoutVatForAmount Expected revenue for units sold, in CZK, without VAT - combines as sum.
   * @param amount Real transaction amount of units sold, as per transaction log – combines as sum.
   * @param saleValueWithVat Sale value of units sold, as per transaction log (real revenue in CZK) – combines as sum.
   * @param saleValueWithoutVat Sale value without VAT of units sold, as per transaction log (real revenue in CZK) – combines as sum.
   * @param vatValue Absolute VAT value [CZK] for sale price (be aware that sale value already includes VAT)
   * @param costValue Cost value of units sold, as per transaction log – combines as sum.
   * @param costValueWithVA Cost value of units sold, including applied vendor allowances
   * @param diffDaysSum Total number of days the price was in effect – combines as sum. The result diff days value is computed as avg,
   *        as denominator is used.
   * @param estimationInPercentSum Estimation in % from SelloutReleaseItemEvaluation#estimationInPercent – combines as average.
   *        FIXME SelloutReleaseItemEvaluation#estimationInPercent is computed for all period price is in effect, not provided interval!!!
   *        TODO I think it should not be here at all, estimation is comparision of expected sales and real sales (FE can do that!!!)
   * @param denominator Value used as denominator within computation of simple avg. Value is increased by one each time you combine
   *        time independent impacts, otherwise value is not changed. Default value is equal to one (initial value).
   */
  function RealImpactBuilder(marginForAmount, profitForAmount, forecast, forecastObsolete, revenueForAmount, revenueWithoutVatForAmount, amount, saleValueWithVat, saleValueWithoutVat, vatValue, costValue, costValueWithVA, diffDaysSum, estimationInPercentSum) {
    var denominator = arguments.length > 14 && arguments[14] !== undefined ? arguments[14] : PriceFormulas_1.PriceFormulas.ONE;

    _classCallCheck(this, RealImpactBuilder);

    this.marginForAmount = marginForAmount;
    this.profitForAmount = profitForAmount;
    this.forecast = forecast;
    this.forecastObsolete = forecastObsolete;
    this.revenueForAmount = revenueForAmount;
    this.revenueWithoutVatForAmount = revenueWithoutVatForAmount;
    this.amount = amount;
    this.saleValueWithVat = saleValueWithVat;
    this.saleValueWithoutVat = saleValueWithoutVat;
    this.vatValue = vatValue;
    this.costValue = costValue;
    this.costValueWithVA = costValueWithVA;
    this.diffDaysSum = diffDaysSum;
    this.estimationInPercentSum = estimationInPercentSum;
    this.denominator = denominator;
  }

  _createClass(RealImpactBuilder, [{
    key: "getValue",
    value: function getValue() {
      return new RealImpactValue_1.RealImpactValue(PriceFormulas_1.PriceFormulas.roundDefault(this.salesVolumeImpact()), // sales volume (quantity) impact for amount units
      PriceFormulas_1.PriceFormulas.roundDefault(this.realMarginForAmount()), // real margin in CZK for amount units
      PriceFormulas_1.PriceFormulas.roundDefault(this.realMarginPercentForAmount()), // real margin in % for amount units
      PriceFormulas_1.PriceFormulas.roundDefault(this.marginImpact()), // margin impact in CZK for amount units
      PriceFormulas_1.PriceFormulas.roundDefault(this.marginImpactPercent()), // margin impact in %
      PriceFormulas_1.PriceFormulas.roundDefault(this.realProfitForAmount()), // real profit in CZK for amount units
      PriceFormulas_1.PriceFormulas.roundDefault(this.realProfitPercentForAmount()), // real profit in % for amount units
      PriceFormulas_1.PriceFormulas.roundDefault(this.profitImpact()), // profit impact in CZK for amount units
      PriceFormulas_1.PriceFormulas.roundDefault(this.profitImpactPercent()), // profit impact in %
      PriceFormulas_1.PriceFormulas.roundDefault(this.revenueImpact()), // revenue impact in CZK for amount units
      PriceFormulas_1.PriceFormulas.roundDefault(this.estimationInPercent()), // estimation in %
      // debug values, to be removed (excluding the columns shown in frontend):
      PriceFormulas_1.PriceFormulas.roundDefault(this.forecast), this.forecastObsolete, PriceFormulas_1.PriceFormulas.roundDefault(this.revenueForAmount), PriceFormulas_1.PriceFormulas.roundDefault(this.amount), // real quantity, newly also shown in FE (LOG-4813)
      PriceFormulas_1.PriceFormulas.roundDefault(this.saleValueWithVat), // real revenue (sales) in CZK, newly also shown in FE (LOG-4813)
      PriceFormulas_1.PriceFormulas.roundDefault(this.saleValueWithoutVat), // real revenue (sales) in CZK without VAT, also shown in FE (LOG-5715)
      PriceFormulas_1.PriceFormulas.roundDefault(this.costValue), this.diffDays());
    }
  }, {
    key: "salesVolumeImpact",
    value: function salesVolumeImpact() {
      // it would be better to handle this within UI, not BE (see TODO within class header for more info)
      return this.forecastObsolete ? big_decimal_1.bigdecimal(0) : this.amount.sub(this.forecast);
    }
  }, {
    key: "marginImpact",
    value: function marginImpact() {
      return this.realMarginForAmount().minus(this.marginForAmount);
    }
  }, {
    key: "marginImpactPercent",
    value: function marginImpactPercent() {
      return PriceFormulas_1.PriceFormulas.computeImpactPercent(this.realMarginForAmount(), this.marginForAmount);
    }
  }, {
    key: "profitImpact",
    value: function profitImpact() {
      return this.realProfitForAmount().minus(this.profitForAmount);
    }
  }, {
    key: "profitImpactPercent",
    value: function profitImpactPercent() {
      return PriceFormulas_1.PriceFormulas.computeImpactPercent(this.realProfitForAmount(), this.profitForAmount);
    }
  }, {
    key: "revenueImpact",
    value: function revenueImpact() {
      return this.saleValueWithoutVat.minus(this.revenueWithoutVatForAmount);
    } // Real profit for amount units

  }, {
    key: "realProfitForAmount",
    value: function realProfitForAmount() {
      // LOG-5827: sale value and cost value is already aggregated for real quantity
      return PriceFormulas_1.PriceFormulas.computeProfit(this.saleValueWithoutVat, this.costValue);
    } // Real profit for amount units in %

  }, {
    key: "realProfitPercentForAmount",
    value: function realProfitPercentForAmount() {
      // LOG-5827: sale value and cost value is already aggregated for real quantity
      return PriceFormulas_1.PriceFormulas.computeProfitPercentFromAbsolute(this.realProfitForAmount(), this.saleValueWithoutVat);
    } // Real margin for amount units

  }, {
    key: "realMarginForAmount",
    value: function realMarginForAmount() {
      // LOG-5827: sale value and cost value is already aggregated for real quantity
      return PriceFormulas_1.PriceFormulas.computeMarginFromPurchasePriceWithVA(this.saleValueWithoutVat, this.costValueWithVA);
    } // Real margin for amount units in %

  }, {
    key: "realMarginPercentForAmount",
    value: function realMarginPercentForAmount() {
      // LOG-5827: sale value and cost value is already aggregated for real quantity
      return PriceFormulas_1.PriceFormulas.computeMarginPercentFromAbsolute(this.realMarginForAmount(), this.saleValueWithoutVat);
    }
  }, {
    key: "diffDays",
    value: function diffDays() {
      return this.diffDaysSum.div(this.denominator).toNumber();
    }
  }, {
    key: "estimationInPercent",
    value: function estimationInPercent() {
      return this.estimationInPercentSum.div(this.denominator);
    }
    /**
     * <p>Combinator of impacts used to group impacts for time dependant period (it does not have to be single day). <b>This combining
     * function does not increase denominator for computation of simple avg.</b></p>
     *
     * <p><b>This function should be used only at the lowest level and the lowest unit (such as zone level of an item).</b></p>
     *
     * @param impact {@link RealImpact} that should be added
     * @returns new instance of {@link RealImpactBuilder} enriched about provided impact
     */

  }, {
    key: "add",
    value: function add(impact) {
      if (!impact) {
        return this;
      }

      if (!(impact instanceof RealImpactBuilder)) {
        throw Error('Real impact is already finalized, cannot combine with another');
      }

      var builder = impact;
      return new RealImpactBuilder(this.marginForAmount.add(builder.marginForAmount), this.profitForAmount.add(builder.profitForAmount), this.forecast.add(builder.forecast), this.forecastObsolete || impact.forecastObsolete, this.revenueForAmount.add(builder.revenueForAmount), this.revenueWithoutVatForAmount.add(builder.revenueWithoutVatForAmount), this.amount.add(builder.amount), this.saleValueWithVat.add(builder.saleValueWithVat), this.saleValueWithoutVat.add(builder.saleValueWithoutVat), this.vatValue.add(builder.vatValue), this.costValue.add(builder.costValue), this.costValueWithVA.add(builder.costValueWithVA), this.diffDaysSum.add(builder.diffDaysSum), this.estimationInPercentSum.add(builder.estimationInPercentSum), this.denominator);
    }
    /**
     * <p>Time independent combinator of impacts. This function does increase denominator for computation of simple avg (+1).</p>
     * <p><b>The function should be used to combine already aggregated impacts at the lowest level / unit to aggregate the impact for
     * upper levels.</b></p>
     *
     * @param impact {@link RealImpact} that should be added
     * @returns new instance of {@link RealImpactBuilder} enriched about provided impact.
     */

  }, {
    key: "addInGroup",
    value: function addInGroup(impact) {
      if (!impact) {
        return this;
      }

      if (!(impact instanceof RealImpactBuilder)) {
        throw Error('Real impact is already finalized, cannot combine with another');
      }

      var builder = impact;
      return new RealImpactBuilder(this.marginForAmount.add(builder.marginForAmount), this.profitForAmount.add(builder.profitForAmount), this.forecast.add(builder.forecast), this.forecastObsolete || impact.forecastObsolete, this.revenueForAmount.add(builder.revenueForAmount), this.revenueWithoutVatForAmount.add(builder.revenueWithoutVatForAmount), this.amount.add(builder.amount), this.saleValueWithVat.add(builder.saleValueWithVat), this.saleValueWithoutVat.add(builder.saleValueWithoutVat), this.vatValue.add(builder.vatValue), this.costValue.add(builder.costValue), this.costValueWithVA.add(builder.costValueWithVA), this.diffDaysSum.add(builder.diffDaysSum), this.estimationInPercentSum.add(builder.estimationInPercentSum), this.denominator.add(builder.denominator));
    }
  }]);

  return RealImpactBuilder;
}();

exports.RealImpactBuilder = RealImpactBuilder;